import React from 'react';
import styled from '@emotion/styled';

import { COLORS, COLORS_BASE } from '../../utils/consts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCircleDot } from '@fortawesome/free-solid-svg-icons';

type TooggleProps = {
    toggle?: boolean,
    active?: boolean,
    radio?: boolean,
    layerId: string,
    toggleLayer: ((e: React.FormEvent<HTMLInputElement>) => void)
}

function Toggle({ toggle = true, layerId, toggleLayer, radio = false }: TooggleProps) {

    return (
        <div>
            <ToggleCheckboxStyle
                type={radio?'radio':'checkbox'}
                id={layerId}
                name={layerId}
                onChange={toggleLayer}
                checked={toggle}
            />
            <ToggleSpanStyle toggle={toggle} radio={radio}>
                {toggle && <FontAwesomeIcon icon={radio?'circle-dot':faCheck} color={radio?COLORS.ICON.MAIN:'white'} size={radio?'lg':'1x'}
                />}
            </ToggleSpanStyle>
        </div>
    );
}

export default Toggle;

const ToggleCheckboxStyle = styled.input<{}>(() => `
    height: 0;
    width: 0;
    visibility: hidden;
    margin-right: 35px;
`);

const ToggleSpanStyle = styled.span<{ toggle?: boolean, radio?: boolean}>(({ toggle = true, radio}) => `
    content: '';
    position: absolute;
    top: 1px;
    left: 2px;
    width: 14px;
    height: 14px;
    border-radius: ${radio? '50px' : '3px'};
    border: 2px solid ${COLORS_BASE.SECONDARY.MAIN.replace(`"`, ``)};
    transition: 0.5s;
    background: ${ 'white'};
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 14px;
    cursor: pointer;
    ${toggle&&!radio && `
        background: ${COLORS_BASE.SECONDARY.MAIN};
    `}
`);